import {
  ADD_NEW_STAFF,
  ADD_STAFF_SUCCESS,
  ADD_STAFF_FAIL,
  GET_STAFF_DATA,
  GET_STAFF_DATA_SUCCESS,
  GET_STAFF_DATA_FAIL,
  UPDATE_STAFF,
  UPDATE_STAFF_SUCCESS,
  UPDATE_STAFF_FAIL,
  DELETE_STAFF,
  DELETE_STAFF_SUCCESS,
  DELETE_STAFF_FAIL,
  GET_STAFF_LIST,
  GET_STAFF_LIST_SUCCESS,
  GET_STAFF_LIST_FAIL,
  SEARCH_STAFF_INCOME_LIST,
  SEARCH_STAFF_INCOME_LIST_SUCCESS,
  SEARCH_STAFF_INCOME_LIST_FAIL,
  GET_STAFF_LEAVE_TYPE_LIST,
  GET_STAFF_LEAVE_TYPE_LIST_SUCCESS,
  GET_STAFF_LEAVE_TYPE_LIST_FAIL,
  ADD_STAFF_LEAVE_TYPE,
  ADD_STAFF_LEAVE_TYPE_SUCCESS,
  ADD_STAFF_LEAVE_TYPE_FAIL,
  UPDATE_STAFF_LEAVE_TYPE,
  UPDATE_STAFF_LEAVE_TYPE_SUCCESS,
  UPDATE_STAFF_LEAVE_TYPE_FAIL,
  DELETE_STAFF_LEAVE_TYPE,
  DELETE_STAFF_LEAVE_TYPE_SUCCESS,
  DELETE_STAFF_LEAVE_TYPE_FAIL,
  CREATE_STAFF_INCOME,
  CREATE_STAFF_INCOME_SUCCESS,
  CREATE_STAFF_INCOME_FAIL,
  GET_STAFF_INCOME_CATEGORY_ITEM_LIST,
  GET_STAFF_INCOME_CATEGORY_ITEM_LIST_SUCCESS,
  GET_STAFF_INCOME_CATEGORY_ITEM_LIST_FAIL,
  GET_STAFF_INCOME_CATEGORY_ITEM_DATA,
  GET_STAFF_INCOME_CATEGORY_ITEM_DATA_SUCCESS,
  GET_STAFF_INCOME_CATEGORY_ITEM_DATA_FAIL,
  CREATE_STAFF_INCOME_CATEGORY_ITEM,
  CREATE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS,
  CREATE_STAFF_INCOME_CATEGORY_ITEM_FAIL,
  UPDATE_STAFF_INCOME_CATEGORY_ITEM,
  UPDATE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS,
  UPDATE_STAFF_INCOME_CATEGORY_ITEM_FAIL,
  DELETE_STAFF_INCOME_CATEGORY_ITEM,
  DELETE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS,
  DELETE_STAFF_INCOME_CATEGORY_ITEM_FAIL,
  GET_STAFF_INCOME_LIST,
  GET_STAFF_INCOME_LIST_SUCCESS,
  GET_STAFF_INCOME_LIST_FAIL,
  GET_STAFF_INCOME_DATA,
  GET_STAFF_INCOME_DATA_SUCCESS,
  GET_STAFF_INCOME_DATA_FAIL,
  UPDATE_STAFF_INCOME,
  UPDATE_STAFF_INCOME_SUCCESS,
  UPDATE_STAFF_INCOME_FAIL,
  DELETE_STAFF_INCOME,
  DELETE_STAFF_INCOME_SUCCESS,
  DELETE_STAFF_INCOME_FAIL,
  GET_STAFF_LEAVE_LIST,
  GET_STAFF_LEAVE_LIST_SUCCESS,
  GET_STAFF_LEAVE_LIST_FAIL,
  GET_STAFF_LEAVE_DATA,
  GET_STAFF_LEAVE_DATA_SUCCESS,
  GET_STAFF_LEAVE_DATA_FAIL,
  UPDATE_STAFF_LEAVE,
  UPDATE_STAFF_LEAVE_SUCCESS,
  UPDATE_STAFF_LEAVE_FAIL,
  DELETE_STAFF_LEAVE,
  DELETE_STAFF_LEAVE_SUCCESS,
  DELETE_STAFF_LEAVE_FAIL,
  CREATE_STAFF_LEAVE,
  CREATE_STAFF_LEAVE_SUCCESS,
  CREATE_STAFF_LEAVE_FAIL,
  SEARCH_STAFF_LEAVE,
  SEARCH_STAFF_LEAVE_SUCCESS,
  SEARCH_STAFF_LEAVE_FAIL,
  GET_STAFF_LEAVE_ALLOWANCE_LIST,
  GET_STAFF_LEAVE_ALLOWANCE_LIST_SUCCESS,
  GET_STAFF_LEAVE_ALLOWANCE_LIST_FAIL,
  GET_STAFF_LEAVE_ALLOWANCE_DATA,
  GET_STAFF_LEAVE_ALLOWANCE_DATA_SUCCESS,
  GET_STAFF_LEAVE_ALLOWANCE_DATA_FAIL,
  UPDATE_STAFF_LEAVE_ALLOWANCE,
  UPDATE_STAFF_LEAVE_ALLOWANCE_SUCCESS,
  UPDATE_STAFF_LEAVE_ALLOWANCE_FAIL,
  DELETE_STAFF_LEAVE_ALLOWANCE,
  DELETE_STAFF_LEAVE_ALLOWANCE_SUCCESS,
  DELETE_STAFF_LEAVE_ALLOWANCE_FAIL,
  CREATE_STAFF_LEAVE_ALLOWANCE,
  CREATE_STAFF_LEAVE_ALLOWANCE_SUCCESS,
  CREATE_STAFF_LEAVE_ALLOWANCE_FAIL,
  SEARCH_STAFF_LEAVE_ALLOWANCE,
  SEARCH_STAFF_LEAVE_ALLOWANCE_SUCCESS,
  SEARCH_STAFF_LEAVE_ALLOWANCE_FAIL,
  SEARCH_STAFF,
  SEARCH_STAFF_SUCCESS,
  SEARCH_STAFF_FAIL,
  SEARCH_STAFF_MEMBERS,
  SEARCH_STAFF_MEMBERS_SUCCESS,
  SEARCH_STAFF_MEMBERS_FAIL,
  CREATE_STAFF_AND_USER,
  CREATE_STAFF_AND_USER_SUCCESS,
  CREATE_STAFF_AND_USER_FAIL,
  GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST,
  GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST_SUCCESS,
  GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST_FAIL,
  GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA,
  GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA_SUCCESS,
  GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA_FAIL,
  CREATE_ORGANISATION_DEPARTMENT_TO_STAFF,
  CREATE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS,
  CREATE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL,
  SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF,
  SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS,
  SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL,
  UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF,
  UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS,
  UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL,
  DELETE_ORGANISATION_DEPARTMENT_TO_STAFF,
  DELETE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS,
  DELETE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL,
  GET_ORGANISATION_DEPARTMENT_LIST,
  GET_ORGANISATION_DEPARTMENT_LIST_SUCCESS,
  GET_ORGANISATION_DEPARTMENT_LIST_FAIL,
  GET_ORGANISATION_DEPARTMENT_DATA,
  GET_ORGANISATION_DEPARTMENT_DATA_SUCCESS,
  GET_ORGANISATION_DEPARTMENT_DATA_FAIL,
  CREATE_ORGANISATION_DEPARTMENT,
  CREATE_ORGANISATION_DEPARTMENT_SUCCESS,
  CREATE_ORGANISATION_DEPARTMENT_FAIL,
  GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY,
  GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY_SUCCESS,
  GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY_FAIL,
  UPDATE_ORGANISATION_DEPARTMENT,
  UPDATE_ORGANISATION_DEPARTMENT_SUCCESS,
  UPDATE_ORGANISATION_DEPARTMENT_FAIL,
  DELETE_ORGANISATION_DEPARTMENT,
  DELETE_ORGANISATION_DEPARTMENT_SUCCESS,
  DELETE_ORGANISATION_DEPARTMENT_FAIL,
  GET_STAFF_TO_STAFF_MANAGER_LIST,
  GET_STAFF_TO_STAFF_MANAGER_LIST_SUCCESS,
  GET_STAFF_TO_STAFF_MANAGER_LIST_FAIL,
  GET_STAFF_TO_STAFF_MANAGER_DATA,
  GET_STAFF_TO_STAFF_MANAGER_DATA_SUCCESS,
  GET_STAFF_TO_STAFF_MANAGER_DATA_FAIL,
  CREATE_STAFF_TO_STAFF_MANAGER,
  CREATE_STAFF_TO_STAFF_MANAGER_SUCCESS,
  CREATE_STAFF_TO_STAFF_MANAGER_FAIL,
  UPDATE_STAFF_TO_STAFF_MANAGER,
  UPDATE_STAFF_TO_STAFF_MANAGER_SUCCESS,
  UPDATE_STAFF_TO_STAFF_MANAGER_FAIL,
  DELETE_STAFF_TO_STAFF_MANAGER,
  DELETE_STAFF_TO_STAFF_MANAGER_SUCCESS,
  DELETE_STAFF_TO_STAFF_MANAGER_FAIL,
  GET_STAFF_RECENT_ACTIVITY_LIST,
  GET_STAFF_RECENT_ACTIVITY_LIST_SUCCESS,
  GET_STAFF_RECENT_ACTIVITY_LIST_FAIL,
  STAFF_ACTIVITY_LOG_SEARCH,
  STAFF_ACTIVITY_LOG_SEARCH_SUCCESS,
  STAFF_ACTIVITY_LOG_SEARCH_FAILURE,
  SEARCH_STAFF_REAL_TIME,
  SEARCH_STAFF_REAL_TIME_SUCCESS,
  SEARCH_STAFF_REAL_TIME_FAIL,
  GET_STAFF_SKILL_SET_LIST,
  GET_STAFF_SKILL_SET_LIST_SUCCESS,
  GET_STAFF_SKILL_SET_LIST_FAIL,
  GET_STAFF_SKILL_SET_DATA,
  GET_STAFF_SKILL_SET_DATA_SUCCESS,
  GET_STAFF_SKILL_SET_DATA_FAIL,
  CREATE_STAFF_SKILL_SET,
  CREATE_STAFF_SKILL_SET_SUCCESS,
  CREATE_STAFF_SKILL_SET_FAIL,
  UPDATE_STAFF_SKILL_SET,
  UPDATE_STAFF_SKILL_SET_SUCCESS,
  UPDATE_STAFF_SKILL_SET_FAIL,
  DELETE_STAFF_SKILL_SET,
  DELETE_STAFF_SKILL_SET_SUCCESS,
  DELETE_STAFF_SKILL_SET_FAIL,
  GET_STAFF_TO_STAFF_SKILL_SET_LIST,
  GET_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS,
  GET_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL,
  GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST,
  GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS,
  GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL,
  GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST,
  GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS,
  GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL,
  GET_STAFF_TO_STAFF_SKILL_SET_DATA,
  GET_STAFF_TO_STAFF_SKILL_SET_DATA_SUCCESS,
  GET_STAFF_TO_STAFF_SKILL_SET_DATA_FAIL,
  CREATE_STAFF_TO_STAFF_SKILL_SET,
  CREATE_STAFF_TO_STAFF_SKILL_SET_SUCCESS,
  CREATE_STAFF_TO_STAFF_SKILL_SET_FAIL,
  UPDATE_STAFF_TO_STAFF_SKILL_SET,
  UPDATE_STAFF_TO_STAFF_SKILL_SET_SUCCESS,
  UPDATE_STAFF_TO_STAFF_SKILL_SET_FAIL,
  DELETE_STAFF_TO_STAFF_SKILL_SET,
  DELETE_STAFF_TO_STAFF_SKILL_SET_SUCCESS,
  DELETE_STAFF_TO_STAFF_SKILL_SET_FAIL,
  SEARCH_STAFF_TO_STAFF_SKILL_SET,
  SEARCH_STAFF_TO_STAFF_SKILL_SET_SUCCESS,
  SEARCH_STAFF_TO_STAFF_SKILL_SET_FAIL,
  SEARCH_STAFF_AVAILABILITY,
  SEARCH_STAFF_AVAILABILITY_SUCCESS,
  SEARCH_STAFF_AVAILABILITY_FAIL,
  SEARCH_STAFF_GPS_LOCATION_HISTORY,
  SEARCH_STAFF_GPS_LOCATION_HISTORY_SUCCESS,
  SEARCH_STAFF_GPS_LOCATION_HISTORY_FAIL,
  GET_STAFF_WORKING_SCHEDULE_RECORD_LIST,
  GET_STAFF_WORKING_SCHEDULE_RECORD_LIST_SUCCESS,
  GET_STAFF_WORKING_SCHEDULE_RECORD_LIST_FAIL,
  GET_STAFF_WORKING_SCHEDULE_RECORD_DATA,
  GET_STAFF_WORKING_SCHEDULE_RECORD_DATA_SUCCESS,
  GET_STAFF_WORKING_SCHEDULE_RECORD_DATA_FAIL,
  CREATE_STAFF_WORKING_SCHEDULE_RECORD,
  CREATE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS,
  CREATE_STAFF_WORKING_SCHEDULE_RECORD_FAIL,
  UPDATE_STAFF_WORKING_SCHEDULE_RECORD,
  UPDATE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS,
  UPDATE_STAFF_WORKING_SCHEDULE_RECORD_FAIL,
  DELETE_STAFF_WORKING_SCHEDULE_RECORD,
  DELETE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS,
  DELETE_STAFF_WORKING_SCHEDULE_RECORD_FAIL,
  GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST,
  GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST_SUCCESS,
  GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST_FAIL,
  GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA,
  GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA_SUCCESS,
  GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA_FAIL,
  CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT,
  CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS,
  CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL,
  UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT,
  UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS,
  UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL,
  DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT,
  DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS,
  DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL,
  GET_STAFF_WORKING_SCHEDULE_LIST,
  GET_STAFF_WORKING_SCHEDULE_LIST_SUCCESS,
  GET_STAFF_WORKING_SCHEDULE_LIST_FAIL,
  GET_STAFF_WORKING_SCHEDULE_DATA,
  GET_STAFF_WORKING_SCHEDULE_DATA_SUCCESS,
  GET_STAFF_WORKING_SCHEDULE_DATA_FAIL,
  CREATE_STAFF_WORKING_SCHEDULE,
  CREATE_STAFF_WORKING_SCHEDULE_SUCCESS,
  CREATE_STAFF_WORKING_SCHEDULE_FAIL,
  UPDATE_STAFF_WORKING_SCHEDULE,
  UPDATE_STAFF_WORKING_SCHEDULE_SUCCESS,
  UPDATE_STAFF_WORKING_SCHEDULE_FAIL,
  DELETE_STAFF_WORKING_SCHEDULE,
  DELETE_STAFF_WORKING_SCHEDULE_SUCCESS,
  DELETE_STAFF_WORKING_SCHEDULE_FAIL,
  SEARCH_STAFF_WORKING_SCHEDULE,
  SEARCH_STAFF_WORKING_SCHEDULE_SUCCESS,
  SEARCH_STAFF_WORKING_SCHEDULE_FAIL,
  SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE,
  SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE_SUCCESS,
  SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE_FAIL,
  CALCULATE_STAFF_WORKING_SCHEDULE,
  CALCULATE_STAFF_WORKING_SCHEDULE_SUCCESS,
  CALCULATE_STAFF_WORKING_SCHEDULE_FAIL,
} from "./actionType";

// ********* Staff List CRUD Action Types *********

// Create New Staff "Create"
export const addNewStaff = (staff) => {
  return {
    type: ADD_NEW_STAFF,
    payload: staff,
  };
};

export const addStaffSuccess = (staff) => {
  return {
    type: ADD_STAFF_SUCCESS,
    payload: staff,
  };
};

export const addStaffFail = (error) => {
  return {
    type: ADD_STAFF_FAIL,
    payload: error,
  };
};

// GET Staff data "Read"

export const getStaffData = (id) => {
  return {
    type: GET_STAFF_DATA,
    payload: id,
  };
};

export const getStaffDataSuccess = (staff) => {
  return {
    type: GET_STAFF_DATA_SUCCESS,
    payload: staff,
  };
};

export const getStaffDataFail = (error) => {
  return {
    type: GET_STAFF_DATA_FAIL,
    payload: error,
  };
};

// Update Staff "Update"

export const updateStaff = (staff) => {
  return {
    type: UPDATE_STAFF,
    payload: staff,
  };
};

export const updateStaffSuccess = (staff) => {
  return {
    type: UPDATE_STAFF_SUCCESS,
    payload: staff,
  };
};

export const updateStaffFail = (error) => {
  return {
    type: UPDATE_STAFF_FAIL,
    payload: error,
  };
};

// Delete Staff "Delete"

export const deleteStaff = (staff) => {
  return {
    type: DELETE_STAFF,
    payload: staff,
  };
};

export const deleteStaffSuccess = (staff) => {
  return {
    type: DELETE_STAFF_SUCCESS,
    payload: staff,
  };
};

export const deleteStaffFail = (error) => {
  return {
    type: DELETE_STAFF_FAIL,
    payload: error,
  };
};

// Get Staff List

export const getStaffList = () => {
  return {
    type: GET_STAFF_LIST,
  };
};

export const getStaffListSuccess = (staff) => {
  return {
    type: GET_STAFF_LIST_SUCCESS,
    payload: staff,
  };
};

export const getStaffListFail = (error) => {
  return {
    type: GET_STAFF_LIST_FAIL,
    payload: error,
  };
};

// Search Staff Income List

export const searchStaffIncomeList = (staff) => {
  return {
    type: SEARCH_STAFF_INCOME_LIST,
    payload: staff,
  };
};

export const searchStaffIncomeListSuccess = (staff) => {
  return {
    type: SEARCH_STAFF_INCOME_LIST_SUCCESS,
    payload: staff,
  };
};

export const searchStaffIncomeListFail = (error) => {
  return {
    type: SEARCH_STAFF_INCOME_LIST_FAIL,
    payload: error,
  };
};

// Get Staff Leave type
export const getStaffLeaveTypeList = () => {
  return {
    type: GET_STAFF_LEAVE_TYPE_LIST,
  };
};

export const getStaffLeaveTypeListSuccess = (staff) => {
  return {
    type: GET_STAFF_LEAVE_TYPE_LIST_SUCCESS,
    payload: staff,
  };
};

export const getStaffLeaveTypeListFail = (error) => {
  return {
    type: GET_STAFF_LEAVE_TYPE_LIST_FAIL,
    payload: error,
  };
};

// Add Staff Leave type
export const addStaffLeaveType = (staff) => {
  return {
    type: ADD_STAFF_LEAVE_TYPE,
    payload: staff,
  };
};

export const addStaffLeaveTypeSuccess = (staff) => {
  return {
    type: ADD_STAFF_LEAVE_TYPE_SUCCESS,
    payload: staff,
  };
};

export const addStaffLeaveTypeFail = (error) => {
  return {
    type: ADD_STAFF_LEAVE_TYPE_FAIL,
    payload: error,
  };
};

// Update Staff Leave type
export const updateStaffLeaveType = (staff) => {
  return {
    type: UPDATE_STAFF_LEAVE_TYPE,
    payload: staff,
  };
};

export const updateStaffLeaveTypeSuccess = (staff) => {
  return {
    type: UPDATE_STAFF_LEAVE_TYPE_SUCCESS,
    payload: staff,
  };
};

export const updateStaffLeaveTypeFail = (error) => {
  return {
    type: UPDATE_STAFF_LEAVE_TYPE_FAIL,
    payload: error,
  };
};

// Delete Staff Leave type
export const deleteStaffLeaveType = (staff) => {
  return {
    type: DELETE_STAFF_LEAVE_TYPE,
    payload: staff,
  };
};

export const deleteStaffLeaveTypeSuccess = (staff) => {
  return {
    type: DELETE_STAFF_LEAVE_TYPE_SUCCESS,
    payload: staff,
  };
};

export const deleteStaffLeaveTypeFail = (error) => {
  return {
    type: DELETE_STAFF_LEAVE_TYPE_FAIL,
    payload: error,
  };
};

// Create Staff Income
export const createStaffIncome = (staff) => {
  return {
    type: CREATE_STAFF_INCOME,
    payload: staff,
  };
};

export const createStaffIncomeSuccess = (staff) => {
  return {
    type: CREATE_STAFF_INCOME_SUCCESS,
    payload: staff,
  };
};

export const createStaffIncomeFail = (error) => {
  return {
    type: CREATE_STAFF_INCOME_FAIL,
    payload: error,
  };
};

//Staff Income Category Item List
export const getStaffIncomeCategoryItemList = () => {
  return {
    type: GET_STAFF_INCOME_CATEGORY_ITEM_LIST,
  };
};

export const getStaffIncomeCategoryItemListSuccess = (staff) => {
  return {
    type: GET_STAFF_INCOME_CATEGORY_ITEM_LIST_SUCCESS,
    payload: staff,
  };
};

export const getStaffIncomeCategoryItemListFail = (error) => {
  return {
    type: GET_STAFF_INCOME_CATEGORY_ITEM_LIST_FAIL,
    payload: error,
  };
};

//Staff Income Category Item data
export const getStaffIncomeCategoryItemData = (staff) => {
  return {
    type: GET_STAFF_INCOME_CATEGORY_ITEM_DATA,
    payload: staff,
  };
};

export const getStaffIncomeCategoryItemDataSuccess = (staff) => {
  return {
    type: GET_STAFF_INCOME_CATEGORY_ITEM_DATA_SUCCESS,
    payload: staff,
  };
};

export const getStaffIncomeCategoryItemDataFail = (error) => {
  return {
    type: GET_STAFF_INCOME_CATEGORY_ITEM_DATA_FAIL,
    payload: error,
  };
};

//Create Staff Income Category Item data
export const createStaffIncomeCategoryItem = (staff) => {
  return {
    type: CREATE_STAFF_INCOME_CATEGORY_ITEM,
    payload: staff,
  };
};

export const createStaffIncomeCategoryItemSuccess = (staff) => {
  return {
    type: CREATE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS,
    payload: staff,
  };
};

export const createStaffIncomeCategoryItemFail = (error) => {
  return {
    type: CREATE_STAFF_INCOME_CATEGORY_ITEM_FAIL,
    payload: error,
  };
};

//Update Staff Income Category Item data
export const updateStaffIncomeCategoryItem = (staff) => {
  return {
    type: UPDATE_STAFF_INCOME_CATEGORY_ITEM,
    payload: staff,
  };
};

export const updateStaffIncomeCategoryItemSuccess = (staff) => {
  return {
    type: UPDATE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS,
    payload: staff,
  };
};

export const updateStaffIncomeCategoryItemFail = (error) => {
  return {
    type: UPDATE_STAFF_INCOME_CATEGORY_ITEM_FAIL,
    payload: error,
  };
};

//Delete Staff Income Category Item data
export const deleteStaffIncomeCategoryItem = (staff) => {
  return {
    type: DELETE_STAFF_INCOME_CATEGORY_ITEM,
    payload: staff,
  };
};

export const deleteStaffIncomeCategoryItemSuccess = (staff) => {
  return {
    type: DELETE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS,
    payload: staff,
  };
};

export const deleteStaffIncomeCategoryItemFail = (error) => {
  return {
    type: DELETE_STAFF_INCOME_CATEGORY_ITEM_FAIL,
    payload: error,
  };
};

//Get Staff Income List
export const getStaffIncomeList = () => {
  return {
    type: GET_STAFF_INCOME_LIST,
  };
};

export const getStaffIncomeListSuccess = (staff) => {
  return {
    type: GET_STAFF_INCOME_LIST_SUCCESS,
    payload: staff,
  };
};

export const getStaffIncomeListFail = (error) => {
  return {
    type: GET_STAFF_INCOME_LIST_FAIL,
    payload: error,
  };
};

// Get Staff Income data
export const getStaffIncomeData = (staff) => {
  return {
    type: GET_STAFF_INCOME_DATA,
    payload: staff,
  };
};

export const getStaffIncomeDataSuccess = (staff) => {
  return {
    type: GET_STAFF_INCOME_DATA_SUCCESS,
    payload: staff,
  };
};

export const getStaffIncomeDataFail = (error) => {
  return {
    type: GET_STAFF_INCOME_DATA_FAIL,
    payload: error,
  };
};

// Update Staff Income
export const updateStaffIncome = (staff) => {
  return {
    type: UPDATE_STAFF_INCOME,
    payload: staff,
  };
};

export const updateStaffIncomeSuccess = (staff) => {
  return {
    type: UPDATE_STAFF_INCOME_SUCCESS,
    payload: staff,
  };
};

export const updateStaffIncomeFail = (error) => {
  return {
    type: UPDATE_STAFF_INCOME_FAIL,
    payload: error,
  };
};

// Delete Staff Income
export const deleteStaffIncome = (staff) => {
  return {
    type: DELETE_STAFF_INCOME,
    payload: staff,
  };
};

export const deleteStaffIncomeSuccess = (staff) => {
  return {
    type: DELETE_STAFF_INCOME_SUCCESS,
    payload: staff,
  };
};

export const deleteStaffIncomeFail = (error) => {
  return {
    type: DELETE_STAFF_INCOME_FAIL,
    payload: error,
  };
};

// Get Staff Leave List
export const getSingleStaffLeaveList = () => {
  return {
    type: GET_STAFF_LEAVE_LIST,
  };
};

export const getSingleStaffLeaveListSuccess = (staff) => {
  return {
    type: GET_STAFF_LEAVE_LIST_SUCCESS,
    payload: staff,
  };
};

export const getSingleStaffLeaveListFail = (error) => {
  return {
    type: GET_STAFF_LEAVE_LIST_FAIL,
    payload: error,
  };
};

// Get Staff Leave data
export const getStaffLeaveData = (staff) => {
  return {
    type: GET_STAFF_LEAVE_DATA,
    payload: staff,
  };
};

export const getStaffLeaveDataSuccess = (staff) => {
  return {
    type: GET_STAFF_LEAVE_DATA_SUCCESS,
    payload: staff,
  };
};

export const getStaffLeaveDataFail = (error) => {
  return {
    type: GET_STAFF_LEAVE_DATA_FAIL,
    payload: error,
  };
};

// Update Staff Leave
export const updateStaffLeave = (staff) => {
  return {
    type: UPDATE_STAFF_LEAVE,
    payload: staff,
  };
};

export const updateStaffLeaveSuccess = (staff) => {
  return {
    type: UPDATE_STAFF_LEAVE_SUCCESS,
    payload: staff,
  };
};

export const updateStaffLeaveFail = (error) => {
  return {
    type: UPDATE_STAFF_LEAVE_FAIL,
    payload: error,
  };
};

// Delete Staff Leave
export const deleteStaffLeave = (staff) => {
  return {
    type: DELETE_STAFF_LEAVE,
    payload: staff,
  };
};

export const deleteStaffLeaveSuccess = (staff) => {
  return {
    type: DELETE_STAFF_LEAVE_SUCCESS,
    payload: staff,
  };
};

export const deleteStaffLeaveFail = (error) => {
  return {
    type: DELETE_STAFF_LEAVE_FAIL,
    payload: error,
  };
};

// Create Staff Leave
export const createStaffLeave = (staff) => {
  return {
    type: CREATE_STAFF_LEAVE,
    payload: staff,
  };
};

export const createStaffLeaveSuccess = (staff) => {
  return {
    type: CREATE_STAFF_LEAVE_SUCCESS,
    payload: staff,
  };
};

export const createStaffLeaveFail = (error) => {
  return {
    type: CREATE_STAFF_LEAVE_FAIL,
    payload: error,
  };
};

// Search Staff Leave
export const searchStaffLeave = (staff) => {
  return {
    type: SEARCH_STAFF_LEAVE,
    payload: staff,
  };
};

export const searchStaffLeaveSuccess = (staff) => {
  return {
    type: SEARCH_STAFF_LEAVE_SUCCESS,
    payload: staff,
  };
};

export const searchStaffLeaveFail = (error) => {
  return {
    type: SEARCH_STAFF_LEAVE_FAIL,
    payload: error,
  };
};

// Get Staff Leave Allowance List
export const getStaffLeaveAllowanceList = () => {
  return {
    type: GET_STAFF_LEAVE_ALLOWANCE_LIST,
  };
};

export const getStaffLeaveAllowanceListSuccess = (staff) => {
  return {
    type: GET_STAFF_LEAVE_ALLOWANCE_LIST_SUCCESS,
    payload: staff,
  };
};

export const getStaffLeaveAllowanceListFail = (error) => {
  return {
    type: GET_STAFF_LEAVE_ALLOWANCE_LIST_FAIL,
    payload: error,
  };
};

// Get Staff Leave Allowance data
export const getStaffLeaveAllowanceData = (staff) => {
  return {
    type: GET_STAFF_LEAVE_ALLOWANCE_DATA,
    payload: staff,
  };
};

export const getStaffLeaveAllowanceDataSuccess = (staff) => {
  return {
    type: GET_STAFF_LEAVE_ALLOWANCE_DATA_SUCCESS,
    payload: staff,
  };
};

export const getStaffLeaveAllowanceDataFail = (error) => {
  return {
    type: GET_STAFF_LEAVE_ALLOWANCE_DATA_FAIL,
    payload: error,
  };
};

// Update Staff Leave Allowance
export const updateStaffLeaveAllowance = (staff) => {
  return {
    type: UPDATE_STAFF_LEAVE_ALLOWANCE,
    payload: staff,
  };
};

export const updateStaffLeaveAllowanceSuccess = (staff) => {
  return {
    type: UPDATE_STAFF_LEAVE_ALLOWANCE_SUCCESS,
    payload: staff,
  };
};

export const updateStaffLeaveAllowanceFail = (error) => {
  return {
    type: UPDATE_STAFF_LEAVE_ALLOWANCE_FAIL,
    payload: error,
  };
};

// Delete Staff Leave Allowance
export const deleteStaffLeaveAllowance = (staff) => {
  return {
    type: DELETE_STAFF_LEAVE_ALLOWANCE,
    payload: staff,
  };
};

export const deleteStaffLeaveAllowanceSuccess = (staff) => {
  return {
    type: DELETE_STAFF_LEAVE_ALLOWANCE_SUCCESS,
    payload: staff,
  };
};

export const deleteStaffLeaveAllowanceFail = (error) => {
  return {
    type: DELETE_STAFF_LEAVE_ALLOWANCE_FAIL,
    payload: error,
  };
};

// Create Staff Leave Allowance
export const createStaffLeaveAllowance = (staff) => {
  return {
    type: CREATE_STAFF_LEAVE_ALLOWANCE,
    payload: staff,
  };
};

export const createStaffLeaveAllowanceSuccess = (staff) => {
  return {
    type: CREATE_STAFF_LEAVE_ALLOWANCE_SUCCESS,
    payload: staff,
  };
};

export const createStaffLeaveAllowanceFail = (error) => {
  return {
    type: CREATE_STAFF_LEAVE_ALLOWANCE_FAIL,
    payload: error,
  };
};

// Search Staff Leave Allowance
export const searchStaffLeaveAllowance = (staff) => {
  return {
    type: SEARCH_STAFF_LEAVE_ALLOWANCE,
    payload: staff,
  };
};

export const searchStaffLeaveAllowanceSuccess = (staff) => {
  return {
    type: SEARCH_STAFF_LEAVE_ALLOWANCE_SUCCESS,
    payload: staff,
  };
};

export const searchStaffLeaveAllowanceFail = (error) => {
  return {
    type: SEARCH_STAFF_LEAVE_ALLOWANCE_FAIL,
    payload: error,
  };
};

// Search Staff
export const searchStaff = (staff) => {
  return {
    type: SEARCH_STAFF,
    payload: staff,
  };
};

export const searchStaffSuccess = (staff) => {
  return {
    type: SEARCH_STAFF_SUCCESS,
    payload: staff,
  };
};

export const searchStaffFail = (error) => {
  return {
    type: SEARCH_STAFF_FAIL,
    payload: error,
  };
};

// Search Staff Members
export const searchStaffMembers = (staff) => {
  return {
    type: SEARCH_STAFF_MEMBERS,
    payload: staff,
  };
};

export const searchStaffMembersSuccess = (staff) => {
  return {
    type: SEARCH_STAFF_MEMBERS_SUCCESS,
    payload: staff,
  };
};

export const searchStaffMembersFail = (error) => {
  return {
    type: SEARCH_STAFF_MEMBERS_FAIL,
    payload: error,
  };
};

// Create Staff And User
export const createStaffAndUser = (staff) => {
  return {
    type: CREATE_STAFF_AND_USER,
    payload: staff,
  };
};

export const createStaffAndUserSuccess = (staff) => {
  return {
    type: CREATE_STAFF_AND_USER_SUCCESS,
    payload: staff,
  };
};

export const createStaffAndUserFail = (error) => {
  return {
    type: CREATE_STAFF_AND_USER_FAIL,
    payload: error,
  };
};

// Get Organisation Department To Staff List
export const getOrganisationDepartmentToStaffList = () => {
  return {
    type: GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST,
  };
};

export const getOrganisationDepartmentToStaffListSuccess = (staff) => {
  return {
    type: GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST_SUCCESS,
    payload: staff,
  };
};

export const getOrganisationDepartmentToStaffListFail = (error) => {
  return {
    type: GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST_FAIL,
    payload: error,
  };
};

// Get Organisation Department To Staff data
export const getOrganisationDepartmentToStaffData = (staff) => {
  return {
    type: GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA,
    payload: staff,
  };
};

export const getOrganisationDepartmentToStaffDataSuccess = (staff) => {
  return {
    type: GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA_SUCCESS,
    payload: staff,
  };
};

export const getOrganisationDepartmentToStaffDataFail = (error) => {
  return {
    type: GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA_FAIL,
    payload: error,
  };
};

// Create Organisation Department To Staff
export const createOrganisationDepartmentToStaff = (staff) => {
  return {
    type: CREATE_ORGANISATION_DEPARTMENT_TO_STAFF,
    payload: staff,
  };
};

export const createOrganisationDepartmentToStaffSuccess = (staff) => {
  return {
    type: CREATE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS,
    payload: staff,
  };
};

export const createOrganisationDepartmentToStaffFail = (error) => {
  return {
    type: CREATE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL,
    payload: error,
  };
};

// Search Organisation Department To Staff
export const searchOrganisationDepartmentToStaff = (staff) => {
  return {
    type: SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF,
    payload: staff,
  };
};

export const searchOrganisationDepartmentToStaffSuccess = (staff) => {
  return {
    type: SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS,
    payload: staff,
  };
};

export const searchOrganisationDepartmentToStaffFail = (error) => {
  return {
    type: SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL,
    payload: error,
  };
};

// Update Organisation Department To Staff
export const updateOrganisationDepartmentToStaff = (staff) => {
  return {
    type: UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF,
    payload: staff,
  };
};

export const updateOrganisationDepartmentToStaffSuccess = (staff) => {
  return {
    type: UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS,
    payload: staff,
  };
};

export const updateOrganisationDepartmentToStaffFail = (error) => {
  return {
    type: UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL,
    payload: error,
  };
};

// Delete Organisation Department To Staff
export const deleteOrganisationDepartmentToStaff = (staff) => {
  return {
    type: DELETE_ORGANISATION_DEPARTMENT_TO_STAFF,
    payload: staff,
  };
};

export const deleteOrganisationDepartmentToStaffSuccess = (staff) => {
  return {
    type: DELETE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS,
    payload: staff,
  };
};

export const deleteOrganisationDepartmentToStaffFail = (error) => {
  return {
    type: DELETE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL,
    payload: error,
  };
};

// Get Organisation Department List
export const getOrganisationDepartmentList = () => {
  return {
    type: GET_ORGANISATION_DEPARTMENT_LIST,
  };
};

export const getOrganisationDepartmentListSuccess = (staff) => {
  return {
    type: GET_ORGANISATION_DEPARTMENT_LIST_SUCCESS,
    payload: staff,
  };
};

export const getOrganisationDepartmentListFail = (error) => {
  return {
    type: GET_ORGANISATION_DEPARTMENT_LIST_FAIL,
    payload: error,
  };
};

// Get Organisation Department data
export const getOrganisationDepartmentData = (staff) => {
  return {
    type: GET_ORGANISATION_DEPARTMENT_DATA,
    payload: staff,
  };
};

export const getOrganisationDepartmentDataSuccess = (staff) => {
  return {
    type: GET_ORGANISATION_DEPARTMENT_DATA_SUCCESS,
    payload: staff,
  };
};

export const getOrganisationDepartmentDataFail = (error) => {
  return {
    type: GET_ORGANISATION_DEPARTMENT_DATA_FAIL,
    payload: error,
  };
};

// Create Organisation Department
export const createOrganisationDepartment = (staff) => {
  return {
    type: CREATE_ORGANISATION_DEPARTMENT,
    payload: staff,
  };
};

export const createOrganisationDepartmentSuccess = (staff) => {
  return {
    type: CREATE_ORGANISATION_DEPARTMENT_SUCCESS,
    payload: staff,
  };
};

export const createOrganisationDepartmentFail = (error) => {
  return {
    type: CREATE_ORGANISATION_DEPARTMENT_FAIL,
    payload: error,
  };
};

// Get Organisation Department Hierarchy Enquiry
export const getOrganisationDepartmentHierarchyEnquiry = () => {
  return {
    type: GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY,
  };
};

export const getOrganisationDepartmentHierarchyEnquirySuccess = (staff) => {
  return {
    type: GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY_SUCCESS,
    payload: staff,
  };
};

export const getOrganisationDepartmentHierarchyEnquiryFail = (error) => {
  return {
    type: GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY_FAIL,
    payload: error,
  };
};

// Update Organisation Department
export const updateOrganisationDepartment = (staff) => {
  return {
    type: UPDATE_ORGANISATION_DEPARTMENT,
    payload: staff,
  };
};

export const updateOrganisationDepartmentSuccess = (staff) => {
  return {
    type: UPDATE_ORGANISATION_DEPARTMENT_SUCCESS,
    payload: staff,
  };
};

export const updateOrganisationDepartmentFail = (error) => {
  return {
    type: UPDATE_ORGANISATION_DEPARTMENT_FAIL,
    payload: error,
  };
};

// Delete Organisation Department
export const deleteOrganisationDepartment = (staff) => {
  return {
    type: DELETE_ORGANISATION_DEPARTMENT,
    payload: staff,
  };
};

export const deleteOrganisationDepartmentSuccess = (staff) => {
  return {
    type: DELETE_ORGANISATION_DEPARTMENT_SUCCESS,
    payload: staff,
  };
};

export const deleteOrganisationDepartmentFail = (error) => {
  return {
    type: DELETE_ORGANISATION_DEPARTMENT_FAIL,
    payload: error,
  };
};

// Get Staff To Staff Manager List
export const getStaffToStaffManagerList = () => {
  return {
    type: GET_STAFF_TO_STAFF_MANAGER_LIST,
  };
};

export const getStaffToStaffManagerListSuccess = (staff) => {
  return {
    type: GET_STAFF_TO_STAFF_MANAGER_LIST_SUCCESS,
    payload: staff,
  };
};

export const getStaffToStaffManagerListFail = (error) => {
  return {
    type: GET_STAFF_TO_STAFF_MANAGER_LIST_FAIL,
    payload: error,
  };
};

// Get Staff To Staff Manager data
export const getStaffToStaffManagerData = (staff) => {
  return {
    type: GET_STAFF_TO_STAFF_MANAGER_DATA,
    payload: staff,
  };
};

export const getStaffToStaffManagerDataSuccess = (staff) => {
  return {
    type: GET_STAFF_TO_STAFF_MANAGER_DATA_SUCCESS,
    payload: staff,
  };
};

export const getStaffToStaffManagerDataFail = (error) => {
  return {
    type: GET_STAFF_TO_STAFF_MANAGER_DATA_FAIL,
    payload: error,
  };
};

// Create Staff To Staff Manager
export const createStaffToStaffManager = (staff) => {
  return {
    type: CREATE_STAFF_TO_STAFF_MANAGER,
    payload: staff,
  };
};

export const createStaffToStaffManagerSuccess = (staff) => {
  return {
    type: CREATE_STAFF_TO_STAFF_MANAGER_SUCCESS,
    payload: staff,
  };
};

export const createStaffToStaffManagerFail = (error) => {
  return {
    type: CREATE_STAFF_TO_STAFF_MANAGER_FAIL,
    payload: error,
  };
};

// Update Staff To Staff Manager
export const updateStaffToStaffManager = (staff) => {
  return {
    type: UPDATE_STAFF_TO_STAFF_MANAGER,
    payload: staff,
  };
};

export const updateStaffToStaffManagerSuccess = (staff) => {
  return {
    type: UPDATE_STAFF_TO_STAFF_MANAGER_SUCCESS,
    payload: staff,
  };
};

export const updateStaffToStaffManagerFail = (error) => {
  return {
    type: UPDATE_STAFF_TO_STAFF_MANAGER_FAIL,
    payload: error,
  };
};

// Delete Staff To Staff Manager
export const deleteStaffToStaffManager = (staff) => {
  return {
    type: DELETE_STAFF_TO_STAFF_MANAGER,
    payload: staff,
  };
};

export const deleteStaffToStaffManagerSuccess = (staff) => {
  return {
    type: DELETE_STAFF_TO_STAFF_MANAGER_SUCCESS,
    payload: staff,
  };
};

export const deleteStaffToStaffManagerFail = (error) => {
  return {
    type: DELETE_STAFF_TO_STAFF_MANAGER_FAIL,
    payload: error,
  };
};

// Get Staff Recent Activity List
export const getStaffRecentActivityList = (payload) => {
  return {
    type: GET_STAFF_RECENT_ACTIVITY_LIST,
    payload: payload,
  };
};

export const getStaffRecentActivityListSuccess = (staff) => {
  return {
    type: GET_STAFF_RECENT_ACTIVITY_LIST_SUCCESS,
    payload: staff,
  };
};

export const getStaffRecentActivityListFail = (error) => {
  return {
    type: GET_STAFF_RECENT_ACTIVITY_LIST_FAIL,
    payload: error,
  };
};

// Search Staff Real Time
export const searchStaffRealTime = (staff) => {
  return {
    type: SEARCH_STAFF_REAL_TIME,
    payload: staff,
  };
};

export const searchStaffRealTimeSuccess = (staff) => {
  return {
    type: SEARCH_STAFF_REAL_TIME_SUCCESS,
    payload: staff,
  };
};

export const searchStaffRealTimeFail = (error) => {
  return {
    type: SEARCH_STAFF_REAL_TIME_FAIL,
    payload: error,
  };
};

// Get Staff Skill Set List
export const getStaffSkillSetList = () => {
  return {
    type: GET_STAFF_SKILL_SET_LIST,
  };
};

export const getStaffSkillSetListSuccess = (staff) => {
  return {
    type: GET_STAFF_SKILL_SET_LIST_SUCCESS,
    payload: staff,
  };
};

export const getStaffSkillSetListFail = (error) => {
  return {
    type: GET_STAFF_SKILL_SET_LIST_FAIL,
    payload: error,
  };
};

// Get Staff Skill Set data
export const getStaffSkillSetData = (staff) => {
  return {
    type: GET_STAFF_SKILL_SET_DATA,
    payload: staff,
  };
};

export const getStaffSkillSetDataSuccess = (staff) => {
  return {
    type: GET_STAFF_SKILL_SET_DATA_SUCCESS,
    payload: staff,
  };
};

export const getStaffSkillSetDataFail = (error) => {
  return {
    type: GET_STAFF_SKILL_SET_DATA_FAIL,
    payload: error,
  };
};

// Create Staff Skill Set
export const createStaffSkillSet = (staff) => {
  return {
    type: CREATE_STAFF_SKILL_SET,
    payload: staff,
  };
};

export const createStaffSkillSetSuccess = (staff) => {
  return {
    type: CREATE_STAFF_SKILL_SET_SUCCESS,
    payload: staff,
  };
};

export const createStaffSkillSetFail = (error) => {
  return {
    type: CREATE_STAFF_SKILL_SET_FAIL,
    payload: error,
  };
};

// Update Staff Skill Set
export const updateStaffSkillSet = (staff) => {
  return {
    type: UPDATE_STAFF_SKILL_SET,
    payload: staff,
  };
};

export const updateStaffSkillSetSuccess = (staff) => {
  return {
    type: UPDATE_STAFF_SKILL_SET_SUCCESS,
    payload: staff,
  };
};

export const updateStaffSkillSetFail = (error) => {
  return {
    type: UPDATE_STAFF_SKILL_SET_FAIL,
    payload: error,
  };
};

// Delete Staff Skill Set
export const deleteStaffSkillSet = (staff) => {
  return {
    type: DELETE_STAFF_SKILL_SET,
    payload: staff,
  };
};

export const deleteStaffSkillSetSuccess = (staff) => {
  return {
    type: DELETE_STAFF_SKILL_SET_SUCCESS,
    payload: staff,
  };
};

export const deleteStaffSkillSetFail = (error) => {
  return {
    type: DELETE_STAFF_SKILL_SET_FAIL,
    payload: error,
  };
};
// Get Staff To Staff Skill Set List
export const getStaffToStaffSkillSetList = () => {
  return {
    type: GET_STAFF_TO_STAFF_SKILL_SET_LIST,
  };
};

export const getStaffToStaffSkillSetListSuccess = (staff) => {
  return {
    type: GET_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS,
    payload: staff,
  };
};

export const getStaffToStaffSkillSetListFail = (error) => {
  return {
    type: GET_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL,
    payload: error,
  };
};

// Get Active Staff To Staff Skill Set List
export const getActiveStaffToStaffSkillSetList = () => {
  return {
    type: GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST,
  };
};

export const getActiveStaffToStaffSkillSetListSuccess = (staff) => {
  return {
    type: GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS,
    payload: staff,
  };
};

export const getActiveStaffToStaffSkillSetListFail = (error) => {
  return {
    type: GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL,
    payload: error,
  };
};

// Get Expired Staff To Staff Skill Set List
export const getExpiredStaffToStaffSkillSetList = () => {
  return {
    type: GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST,
  };
};

export const getExpiredStaffToStaffSkillSetListSuccess = (staff) => {
  return {
    type: GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS,
    payload: staff,
  };
};

export const getExpiredStaffToStaffSkillSetListFail = (error) => {
  return {
    type: GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL,
    payload: error,
  };
};

// Get Staff To Staff Skill Set data
export const getStaffToStaffSkillSetData = (staff) => {
  return {
    type: GET_STAFF_TO_STAFF_SKILL_SET_DATA,
    payload: staff,
  };
};

export const getStaffToStaffSkillSetDataSuccess = (staff) => {
  return {
    type: GET_STAFF_TO_STAFF_SKILL_SET_DATA_SUCCESS,
    payload: staff,
  };
};

export const getStaffToStaffSkillSetDataFail = (error) => {
  return {
    type: GET_STAFF_TO_STAFF_SKILL_SET_DATA_FAIL,
    payload: error,
  };
};

// Create Staff To Staff Skill Set
export const createStaffToStaffSkillSet = (staff) => {
  return {
    type: CREATE_STAFF_TO_STAFF_SKILL_SET,
    payload: staff,
  };
};

export const createStaffToStaffSkillSetSuccess = (staff) => {
  return {
    type: CREATE_STAFF_TO_STAFF_SKILL_SET_SUCCESS,
    payload: staff,
  };
};

export const createStaffToStaffSkillSetFail = (error) => {
  return {
    type: CREATE_STAFF_TO_STAFF_SKILL_SET_FAIL,
    payload: error,
  };
};

// Update Staff To Staff Skill Set
export const updateStaffToStaffSkillSet = (staff) => {
  return {
    type: UPDATE_STAFF_TO_STAFF_SKILL_SET,
    payload: staff,
  };
};

export const updateStaffToStaffSkillSetSuccess = (staff) => {
  return {
    type: UPDATE_STAFF_TO_STAFF_SKILL_SET_SUCCESS,
    payload: staff,
  };
};

export const updateStaffToStaffSkillSetFail = (error) => {
  return {
    type: UPDATE_STAFF_TO_STAFF_SKILL_SET_FAIL,
    payload: error,
  };
};

// Delete Staff To Staff Skill Set
export const deleteStaffToStaffSkillSet = (staff) => {
  return {
    type: DELETE_STAFF_TO_STAFF_SKILL_SET,
    payload: staff,
  };
};

export const deleteStaffToStaffSkillSetSuccess = (staff) => {
  return {
    type: DELETE_STAFF_TO_STAFF_SKILL_SET_SUCCESS,
    payload: staff,
  };
};

export const deleteStaffToStaffSkillSetFail = (error) => {
  return {
    type: DELETE_STAFF_TO_STAFF_SKILL_SET_FAIL,
    payload: error,
  };
};

// Search Staff To Staff Skill Set
export const searchStaffToStaffSkillSet = (staff) => {
  return {
    type: SEARCH_STAFF_TO_STAFF_SKILL_SET,
    payload: staff,
  };
};

export const searchStaffToStaffSkillSetSuccess = (staff) => {
  return {
    type: SEARCH_STAFF_TO_STAFF_SKILL_SET_SUCCESS,
    payload: staff,
  };
};

export const searchStaffToStaffSkillSetFail = (error) => {
  return {
    type: SEARCH_STAFF_TO_STAFF_SKILL_SET_FAIL,
    payload: error,
  };
};

// Search Staff Availability
export const searchStaffAvailability = (staff) => {
  return {
    type: SEARCH_STAFF_AVAILABILITY,
    payload: staff,
  };
};

export const searchStaffAvailabilitySuccess = (staff) => {
  return {
    type: SEARCH_STAFF_AVAILABILITY_SUCCESS,
    payload: staff,
  };
};
export const searchStaffAvailabilityFail = (error) => {
  return {
    type: SEARCH_STAFF_AVAILABILITY_FAIL,
    payload: error,
  };
};

// Search Staff GPS Location History
export const searchStaffGPSLocationHistory = (staff) => {
  return {
    type: SEARCH_STAFF_GPS_LOCATION_HISTORY,
    payload: staff,
  };
};

export const searchStaffGPSLocationHistorySuccess = (staff) => {
  return {
    type: SEARCH_STAFF_GPS_LOCATION_HISTORY_SUCCESS,
    payload: staff,
  };
};

export const searchStaffGPSLocationHistoryFail = (error) => {
  return {
    type: SEARCH_STAFF_GPS_LOCATION_HISTORY_FAIL,
    payload: error,
  };
};

// Get Staff Working Schedule Record List
export const getStaffWorkingScheduleRecordList = () => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_RECORD_LIST,
  };
};

export const getStaffWorkingScheduleRecordListSuccess = (staff) => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_RECORD_LIST_SUCCESS,
    payload: staff,
  };
};

export const getStaffWorkingScheduleRecordListFail = (error) => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_RECORD_LIST_FAIL,
    payload: error,
  };
};

// Get Staff Working Schedule Record data
export const getStaffWorkingScheduleRecordData = (staff) => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_RECORD_DATA,
    payload: staff,
  };
};

export const getStaffWorkingScheduleRecordDataSuccess = (staff) => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_RECORD_DATA_SUCCESS,
    payload: staff,
  };
};

export const getStaffWorkingScheduleRecordDataFail = (error) => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_RECORD_DATA_FAIL,
    payload: error,
  };
};

// Create Staff Working Schedule Record
export const createStaffWorkingScheduleRecord = (staff) => {
  return {
    type: CREATE_STAFF_WORKING_SCHEDULE_RECORD,
    payload: staff,
  };
};

export const createStaffWorkingScheduleRecordSuccess = (staff) => {
  return {
    type: CREATE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS,
    payload: staff,
  };
};

export const createStaffWorkingScheduleRecordFail = (error) => {
  return {
    type: CREATE_STAFF_WORKING_SCHEDULE_RECORD_FAIL,
    payload: error,
  };
};

// Update Staff Working Schedule Record
export const updateStaffWorkingScheduleRecord = (staff) => {
  return {
    type: UPDATE_STAFF_WORKING_SCHEDULE_RECORD,
    payload: staff,
  };
};

export const updateStaffWorkingScheduleRecordSuccess = (staff) => {
  return {
    type: UPDATE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS,
    payload: staff,
  };
};

export const updateStaffWorkingScheduleRecordFail = (error) => {
  return {
    type: UPDATE_STAFF_WORKING_SCHEDULE_RECORD_FAIL,
    payload: error,
  };
};

// Delete Staff Working Schedule Record
export const deleteStaffWorkingScheduleRecord = (staff) => {
  return {
    type: DELETE_STAFF_WORKING_SCHEDULE_RECORD,
    payload: staff,
  };
};

export const deleteStaffWorkingScheduleRecordSuccess = (staff) => {
  return {
    type: DELETE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS,
    payload: staff,
  };
};

export const deleteStaffWorkingScheduleRecordFail = (error) => {
  return {
    type: DELETE_STAFF_WORKING_SCHEDULE_RECORD_FAIL,
    payload: error,
  };
};

// Get Staff Working Schedule Record Adjustment List
export const getStaffWorkingScheduleRecordAdjustmentList = () => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST,
  };
};

export const getStaffWorkingScheduleRecordAdjustmentListSuccess = (staff) => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST_SUCCESS,
    payload: staff,
  };
};

export const getStaffWorkingScheduleRecordAdjustmentListFail = (error) => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST_FAIL,
    payload: error,
  };
};

// Get Staff Working Schedule Record Adjustment data
export const getStaffWorkingScheduleRecordAdjustmentData = (staff) => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA,
    payload: staff,
  };
};

export const getStaffWorkingScheduleRecordAdjustmentDataSuccess = (staff) => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA_SUCCESS,
    payload: staff,
  };
};

export const getStaffWorkingScheduleRecordAdjustmentDataFail = (error) => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA_FAIL,
    payload: error,
  };
};

// Create Staff Working Schedule Record Adjustment
export const createStaffWorkingScheduleRecordAdjustment = (staff) => {
  return {
    type: CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT,
    payload: staff,
  };
};

export const createStaffWorkingScheduleRecordAdjustmentSuccess = (staff) => {
  return {
    type: CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS,
    payload: staff,
  };
};

export const createStaffWorkingScheduleRecordAdjustmentFail = (error) => {
  return {
    type: CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL,
    payload: error,
  };
};

// Update Staff Working Schedule Record Adjustment
export const updateStaffWorkingScheduleRecordAdjustment = (staff) => {
  return {
    type: UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT,
    payload: staff,
  };
};

export const updateStaffWorkingScheduleRecordAdjustmentSuccess = (staff) => {
  return {
    type: UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS,
    payload: staff,
  };
};

export const updateStaffWorkingScheduleRecordAdjustmentFail = (error) => {
  return {
    type: UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL,
    payload: error,
  };
};

// Delete Staff Working Schedule Record Adjustment
export const deleteStaffWorkingScheduleRecordAdjustment = (staff) => {
  return {
    type: DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT,
    payload: staff,
  };
};

export const deleteStaffWorkingScheduleRecordAdjustmentSuccess = (staff) => {
  return {
    type: DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS,
    payload: staff,
  };
};

export const deleteStaffWorkingScheduleRecordAdjustmentFail = (error) => {
  return {
    type: DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL,
    payload: error,
  };
};

// Get Staff Working Schedule List
export const getStaffWorkingScheduleList = () => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_LIST,
  };
};

export const getStaffWorkingScheduleListSuccess = (staff) => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_LIST_SUCCESS,
    payload: staff,
  };
};

export const getStaffWorkingScheduleListFail = (error) => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_LIST_FAIL,
    payload: error,
  };
};

// Get Staff Working Schedule data
export const getStaffWorkingScheduleData = (staff) => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_DATA,
    payload: staff,
  };
};

export const getStaffWorkingScheduleDataSuccess = (staff) => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_DATA_SUCCESS,
    payload: staff,
  };
};

export const getStaffWorkingScheduleDataFail = (error) => {
  return {
    type: GET_STAFF_WORKING_SCHEDULE_DATA_FAIL,
    payload: error,
  };
};

// Create Staff Working Schedule
export const createStaffWorkingSchedule = (staff) => {
  return {
    type: CREATE_STAFF_WORKING_SCHEDULE,
    payload: staff,
  };
};

export const createStaffWorkingScheduleSuccess = (staff) => {
  return {
    type: CREATE_STAFF_WORKING_SCHEDULE_SUCCESS,
    payload: staff,
  };
};

export const createStaffWorkingScheduleFail = (error) => {
  return {
    type: CREATE_STAFF_WORKING_SCHEDULE_FAIL,
    payload: error,
  };
};

// Update Staff Working Schedule
export const updateStaffWorkingSchedule = (staff) => {
  return {
    type: UPDATE_STAFF_WORKING_SCHEDULE,
    payload: staff,
  };
};

export const updateStaffWorkingScheduleSuccess = (staff) => {
  return {
    type: UPDATE_STAFF_WORKING_SCHEDULE_SUCCESS,
    payload: staff,
  };
};

export const updateStaffWorkingScheduleFail = (error) => {
  return {
    type: UPDATE_STAFF_WORKING_SCHEDULE_FAIL,
    payload: error,
  };
};

// Delete Staff Working Schedule
export const deleteStaffWorkingSchedule = (staff) => {
  return {
    type: DELETE_STAFF_WORKING_SCHEDULE,
    payload: staff,
  };
};

export const deleteStaffWorkingScheduleSuccess = (staff) => {
  return {
    type: DELETE_STAFF_WORKING_SCHEDULE_SUCCESS,
    payload: staff,
  };
};

export const deleteStaffWorkingScheduleFail = (error) => {
  return {
    type: DELETE_STAFF_WORKING_SCHEDULE_FAIL,
    payload: error,
  };
};

// Search Staff working schedule
export const searchStaffWorkingSchedule = (staff) => {
  return {
    type: SEARCH_STAFF_WORKING_SCHEDULE,
    payload: staff,
  };
};

export const searchStaffWorkingScheduleSuccess = (staff) => {
  return {
    type: SEARCH_STAFF_WORKING_SCHEDULE_SUCCESS,
    payload: staff,
  };
};

export const searchStaffWorkingScheduleFail = (error) => {
  return {
    type: SEARCH_STAFF_WORKING_SCHEDULE_FAIL,
    payload: error,
  };
};

// Search Staff working schedule for cloning (isolated channel — does not touch
// the current staff's on-page schedule search state).
export const searchStaffWorkingScheduleForClone = (staff) => {
  return {
    type: SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE,
    payload: staff,
  };
};

export const searchStaffWorkingScheduleForCloneSuccess = (staff) => {
  return {
    type: SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE_SUCCESS,
    payload: staff,
  };
};

export const searchStaffWorkingScheduleForCloneFail = (error) => {
  return {
    type: SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE_FAIL,
    payload: error,
  };
};

// Calculate Staff Working Schedule
export const calculateStaffWorkingSchedule = (staff) => {
  return {
    type: CALCULATE_STAFF_WORKING_SCHEDULE,
    payload: staff,
  };
};

export const calculateStaffWorkingScheduleSuccess = (staff) => {
  return {
    type: CALCULATE_STAFF_WORKING_SCHEDULE_SUCCESS,
    payload: staff,
  };
};

export const calculateStaffWorkingScheduleFail = (error) => {
  return {
    type: CALCULATE_STAFF_WORKING_SCHEDULE_FAIL,
    payload: error,
  };
};

//STAFF_ACTIVITY_LOG_SEARCH
export const staffActivityLogSearch = (payload) => ({
  type: STAFF_ACTIVITY_LOG_SEARCH,
  payload,
});

export const staffActivityLogSearchSuccess = (payload) => ({
  type: STAFF_ACTIVITY_LOG_SEARCH_SUCCESS,
  payload,
});

export const staffActivityLogSearchFailure = (payload) => ({
  type: STAFF_ACTIVITY_LOG_SEARCH_FAILURE,
  payload,
});
